import React from 'react';
import * as s from './styles.scss';

export const countriesWithUniqueSofortIcon: string[] = [
  'de',
  'en',
  'es',
  'fr',
  'it',
  'nl',
  'pl',
];

const fallbackCountry: string = 'en';

export const SofortIcon: React.FunctionComponent<{
  lang: string;
}> = (props) => {
  let imageSource: string;

  const lang = countriesWithUniqueSofortIcon.includes(props.lang)
    ? props.lang
    : fallbackCountry;
  imageSource = `https://static.parastorage.com/services/cashier-payments-widget/1.501.0/assets/img/sofort-icons/sofort_${lang}.svg`;

  return (
    <div className={s.logoContainer}>
      <img src={imageSource} />
    </div>
  );
};
SofortIcon.displayName = 'SofortIcon';
